module.exports = require("@vercel/blob/client");